<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Sign Up</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Sign Up</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Start Sign up Area -->
<div class="sign-up-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="text-center mb-4">
                   <div class="fs-3 text-black fw-semibold mb-2">Create An Account!</div>
                    <p class="text-muted mb-0">Fill in your details to create your account.</p>
                </div>

                <div class="card auth-card">
                    <div class="card-body p-4 p-md-5">
                        <form [formGroup]="registerForm">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="first_name" class="form-label">First Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="first_name" placeholder="First Name"
                                        formControlName="first_name">
                                    <div class="text-danger small mt-2" *ngIf="registerForm.controls['first_name'].invalid &&
                                                                (registerForm.controls['first_name'].dirty ||
                                                                    registerForm.controls['first_name'].touched || isSubmit)
                                                            ">
                                        <span *ngIf="
                                                                    registerForm.controls['first_name'].errors
                                                                        .required
                                                                ">
                                            Please enter your first name!
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label for="last_name" class="form-label">Last Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="last_name" placeholder="Last Name"
                                        formControlName="last_name">
                                    <div class="text-danger small mt-2" *ngIf="
                                                                                    registerForm.controls['last_name'].invalid &&
                                                                                    (registerForm.controls['last_name'].dirty ||
                                                                                        registerForm.controls['last_name'].touched || isSubmit)
                                                                                ">
                                        <span *ngIf="
                                                                                        registerForm.controls['last_name'].errors
                                                                                            .required
                                                                ">
                                            Please enter your last name!
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="phone_no" class="form-label">Phone Number <span class="text-danger">*</span></label>
                                <input type="number" (wheel)="stopScrollingWheel($event)" class="form-control"
                                    id="phone_no" placeholder="Enter Your Phone No" formControlName="phone_no">
                                <div class="text-danger small mt-2" *ngIf="
                                                        registerForm.controls['phone_no'].invalid &&
                                                        (registerForm.controls['phone_no'].dirty ||
                                                            registerForm.controls['phone_no'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="
                                                            registerForm.controls['phone_no'].errors
                                                                .required
                                                        ">
                                        Please enter your phone number!
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="email" class="form-label">Email Address <span class="text-danger">*</span></label>
                                <input type="email" class="form-control" id="email" placeholder="Email Address"
                                    formControlName="email" name="email">
                                <div class="text-danger small mt-2" *ngIf="
                                                        registerForm.controls['email'].invalid &&
                                                        (registerForm.controls['email'].dirty ||
                                                            registerForm.controls['email'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="
                                                            registerForm.controls['email'].errors
                                                                .required
                                                        ">
                                        Please enter your email address!
                                    </span>
                                    <span *ngIf="registerForm.controls['email'].errors.email">
                                        Please enter a valid email address!
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input type="password" class="form-control" formControlName="password" id="password"
                                        placeholder="Password" autocomplete="new-password" #passwordField>
                                    <button class="btn btn-outline-secondary" type="button" (click)="
                                                                                            passwordField.type === 'password'
                                                                                                ? (passwordField.type = 'text')
                                                                                                : (passwordField.type = 'password')
                                                                                        ">
                                        <i class="far fa-eye" *ngIf="passwordField.type === 'password'"></i>
                                        <i class="fa fa-eye-slash" *ngIf="passwordField.type === 'text'"></i>
                                    </button>
                                </div>
                                <div class="text-danger small mt-2" *ngIf="
                                                        registerForm.controls['password'].invalid &&
                                                        (registerForm.controls['password'].dirty ||
                                                            registerForm.controls['password'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="
                                                            registerForm.controls['password'].errors
                                                                .required
                                                        ">
                                        Please enter your password!
                                    </span>
                                    <span *ngIf="registerForm.controls['password'].errors?.minlength">
                                        Password must be at least 8 characters long.
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="confirm_password" class="form-label">Confirm Password <span class="text-danger">*</span></label>
                                <input type="password" class="form-control" id="confirm_password" placeholder="Confirm Password"
                                    formControlName="confirm_password">
                                <div class="text-danger small mt-2" *ngIf="
                                                        registerForm.controls['confirm_password'].invalid &&
                                                        (registerForm.controls['confirm_password'].dirty ||
                                                            registerForm.controls['confirm_password'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="
                                                            registerForm.controls['confirm_password'].errors
                                                                .required
                                                        ">
                                        Please enter your Confirm Password!
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                                <input type="address" class="form-control" id="address" formControlName="address" name="address"
                                    placeholder="Address">
                                <div class="text-danger small mt-2" *ngIf="registerForm.controls['address'].invalid &&(registerForm.controls['address'].dirty || registerForm.controls['address'].touched || isSubmit) ">
                                    <span *ngIf="registerForm.controls['address'].errors.required">
                                        Please enter your address!
                                    </span>
                                </div>
                            </div>

                            <div class="mb-4">
                                <label class="form-label d-block">Gender <span class="text-danger">*</span></label>
                                <div class="form-check form-check-inline">
                                    <input type="radio" name="gender" value="Male" formControlName="gender"
                                        class="form-check-input" id="gender_male" />
                                    <label class="form-check-label" for="gender_male">Male</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="radio" name="gender" formControlName="gender" value="Female"
                                        class="form-check-input" id="gender_female" />
                                    <label class="form-check-label" for="gender_female">Female</label>
                                </div>
                            </div>

                            <div class="text-center mb-4">
                                <button class="btn btn-blink" type="button" (click)="createUsers()">
                                    <span>Sign Up</span>
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            <p class="text-center text-muted mb-0">
                                Already have an account? <a routerLink="/sign-in" class="text-decoration-none fw-semibold">Sign In</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Sign up  Area -->
